import { render, staticRenderFns } from "./_diagnosis.tab.vue?vue&type=template&id=3cf33ebb&scoped=true"
import script from "./_diagnosis.tab.vue?vue&type=script&lang=js"
export * from "./_diagnosis.tab.vue?vue&type=script&lang=js"
import style0 from "./_diagnosis.tab.vue?vue&type=style&index=0&id=3cf33ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf33ebb",
  null
  
)

export default component.exports